import BeatSaber from './BeatSaber';
import Blindsight from './Blindsight';
import CharityStream from './CharityStream';
import DarkOfKnight from './DarkOfKnight';
import DisorientExpress from './DisorientExpress';
import DungeonsAndDining from './DungeonsAndDining';
import ETForTheAtari from './ETForTheAtari';
import Gazebo from './Gazebo';
import HLAlyx from './HLAlyx';
import PotionPapa from './PotionPapa';
import ResearchGeocaching from './ResearchGeocaching';
import RiverWipeout from './RiverWipeout';
import SFM from './SFM';
import SHOE from './SHOE';
import Stonks from './Stonks';
import TwitchSpeaks from './TwitchSpeaks';
import TwitchTop from './TwitchTop';

export const BeatSaberImages = {
    brandingImage: BeatSaber.Dad,
    gallery: Object.values(BeatSaber)
}

export const BlindsightImages = {
    brandingImage: Blindsight.Chemicals,
    gallery: Object.values(Blindsight)
}

export const CharityStreamImages = {
    brandingImage: CharityStream.Landing,
    gallery: Object.values(CharityStream)
}

export const DarkOfKnightImages = {
    brandingImage: DarkOfKnight.LitUp,
    gallery: Object.values(DarkOfKnight)
}

export const DisorientExpressImages = {
    brandingImage: DisorientExpress.Trains,
    gallery: Object.values(DisorientExpress)
}

export const DungeonsAndDiningImages = {
    brandingImage: DungeonsAndDining.Menu,
    gallery: Object.values(DungeonsAndDining)
}

export const ETForTheAtariImages = {
    brandingImage: ETForTheAtari.Title,
    gallery: Object.values(ETForTheAtari)
}

export const GazeboImages = {
    brandingImage: Gazebo.Gazebo,
    gallery: Object.values(Gazebo)
}

export const HLAlyxImages = {
    brandingImage: HLAlyx.Combat,
    gallery: Object.values(HLAlyx)
}

export const PotionPapaImages = {
    brandingImage: PotionPapa.Brewing,
    gallery: Object.values(PotionPapa)
}

export const ResearchGeocachingImages = {
    brandingImage: ResearchGeocaching.Map,
    gallery: Object.values(ResearchGeocaching)
}

export const RiverWipeoutImages = {
    brandingImage: RiverWipeout.Title,
    gallery: Object.values(RiverWipeout)
}

export const SFMImages = {
    brandingImage: SFM.ScrapBackground,
    gallery: Object.values(SFM)
}

export const SHOEImages = {
    brandingImage: SHOE.Changes,
    gallery: Object.values(SHOE)
}

export const StonksImages = {
    brandingImage: Stonks.Main,
    gallery: Object.values(Stonks)
}

export const TwitchSpeaksImages = {
    brandingImage: TwitchSpeaks.Server,
    gallery: Object.values(TwitchSpeaks)
}

export const TwitchTopImages = {
    brandingImage: TwitchTop.Clip1,
    gallery: Object.values(TwitchTop)
}